import { render } from "./CostosPersonalCatPorcent.vue?vue&type=template&id=52801ff5&scoped=true"
import script from "./CostosPersonalCatPorcent.vue?vue&type=script&lang=js"
export * from "./CostosPersonalCatPorcent.vue?vue&type=script&lang=js"

import "./CostosPersonalCatPorcent.vue?vue&type=style&index=0&id=52801ff5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-52801ff5"

export default script